/**
 * When a main menu item is clicked, close all other open menu items
 * (so only one menu item is open at a time)
 */
export default function mainNavToggleOpenMenuItem() {
  const navFirstLevelItems = document.querySelectorAll('#mainNavigation .navigation-item--first-level');
  if (!navFirstLevelItems) return;

  navFirstLevelItems.forEach((navElement) => {
    navElement.addEventListener('click', () => {
      _closeOtherNavItems(navFirstLevelItems, navElement)
    });
  })
}

/**
 * Iterate all menu items, and close all that are not the clicked item
 *
 * @param navItems
 * @param clickedNavItem
 * @private
 */
function _closeOtherNavItems(navItems, clickedNavItem) {
  navItems.forEach((navItem) => {
    if (navItem !== clickedNavItem) {
      const navItemInput = navItem.querySelector('.navigation-item__state');
      if (navItemInput) navItemInput.checked = false;
    }
  });
}
